import CryptoJS from 'crypto-js';
import generateRandomString from './random';
function generateCodeChallenge(codeVerifier) {
    return base64URL(CryptoJS.SHA256(codeVerifier));
}
function base64URL(value) {
    return value
        .toString(CryptoJS.enc.Base64)
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
}
export default function generatePkce() {
    const codeVerifier = generateRandomString(128);
    const codeChallenge = generateCodeChallenge(codeVerifier);
    return {
        codeVerifier: codeVerifier,
        codeChallenge: codeChallenge,
    };
}
//# sourceMappingURL=generatePkce.js.map